export default {
    title: 'Aktivitäten',
    noActivities: 'Noch keine Aktivitäten',
    noChanges: 'Keine Änderungen',
    moreChanges: 'keine weiteren Änderungen | eine weitere Änderung | {count} weitere Änderungen',
    changes: 'Änderungen'
}
